<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-transparent md-absolute"
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <div class="md-title">
          <img src="@/assets/img/logos/YNBLOGO-color.png" class="nav-logo" />
        </div>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list>
              <li @click="closeNavBarMobile" class="md-list-item">
                <router-link
                  :to="{ name: 'index' }"
                  exact
                  class="md-list-item-router md-list-item-container md-button-clean"
                >
                  <div class="md-list-item-content">
                    <div>
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-white md-simple"
                      >
                        <p>首页</p>
                      </md-button>
                    </div>
                  </div>
                </router-link>
              </li>

              <li class="md-list-item">
                <a
                  class="md-list-item-router md-list-item-container md-button-clean dropdown"
                  :class="{'router-link-active': isProductRoute}"
                >
                  <div class="md-list-item-content">
                    <drop-down direction="down">
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-white md-simple dropdown-toggle"
                        data-toggle="dropdown"
                      >
                        <p>产品列表</p>
                      </md-button>
                      <ul class="dropdown-menu dropdown-with-icons">
                        <li @click="closeNavBarMobile">
                          <router-link :to="{ name: 'products.wine' }">
                            <i class="fas fa-glass-cheers fa-icon"/>
                            <p>高档酒水</p>
                          </router-link>
                        </li>
                        <li @click="closeNavBarMobile">
                          <router-link :to="{ name: 'products.seafood' }">
                            <i class="fas fa-fish fa-icon"/>
                            <p>海鲜牛排</p>
                          </router-link>
                        </li>
                        <li @click="closeNavBarMobile">
                          <router-link :to="{ name: 'products.food' }">
                            <i class="fas fa-carrot fa-icon"/>
                            <p>农副产品</p>
                          </router-link>
                        </li>
                        <li @click="closeNavBarMobile">
                          <router-link :to="{ name: 'products.nutrition' }">
                            <i class="material-icons">eco</i>
                            <p>营养补品</p>
                          </router-link>
                        </li>
                      </ul>
                    </drop-down>
                  </div>
                </a>
              </li>

              <li @click="closeNavBarMobile" class="md-list-item">
                <router-link
                  :to="{ name: 'login' }"
                  exact
                  class="md-list-item-router md-list-item-container md-button-clean"
                >
                  <div class="md-list-item-content">
                    <div>
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-white md-simple"
                      >
                        <p>用户登录</p>
                      </md-button>
                    </div>
                  </div>
                </router-link>
              </li>

              <template v-if="false">
                <md-list-item
                  href="https://twitter.com/ynbtech"
                  target="_blank"
                >
                  <i class="fab fa-twitter"></i>
                  <p class="hidden-lg">Twitter</p>
                  <md-tooltip md-direction="bottom"
                    >Follow us on Twitter</md-tooltip
                  >
                </md-list-item>
                <md-list-item
                  href="https://www.facebook.com/ynbtech"
                  target="_blank"
                >
                  <i class="fab fa-facebook-square"></i>
                  <p class="hidden-lg">Facebook</p>
                  <md-tooltip md-direction="bottom"
                    >Like us on Facebook</md-tooltip
                  >
                </md-list-item>
                <md-list-item
                  href="https://www.instagram.com/ynbtech"
                  target="_blank"
                >
                  <i class="fab fa-instagram"></i>
                  <p class="hidden-lg">Instagram</p>
                  <md-tooltip md-direction="bottom"
                    >Follow us on Instagram</md-tooltip
                  >
                </md-list-item>
              </template>
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import { navContent } from '@/language';
import MobileMenu from "@/layout/MobileMenu";
export default {
  components: {
    MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false
    };
  },
  computed: {
    isProductRoute() {
      const { name } = this.$route;
      return name && name.split('.')[0] === 'products';
    }
  },
  methods: {
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    closeNavBarMobile() {
      this.NavbarStore.showNavbar = false;
      this.toggledClass = false;
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `md-${this.type}`;
        navbarColor.classList.remove("md-transparent");
        this.showTextLogo = false;
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = "";
          navbarColor.classList.add("md-transparent");
        }
        this.showTextLogo = true;
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    },
    scrollToElement() {
      let element_id = document.getElementById("downloadSection");
      if (element_id) {
        element_id.scrollIntoView({ block: "end", behavior: "smooth" });
      }
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  },
};
</script>

<style lang="scss" scoped>
.nav-logo {
  height: 1rem;
}

.fa-icon {
  color: #888;
  margin: 0 3px;
  font-size: 15px;
}

.dropdown-with-icons a:hover {
  .fa-icon {
    color: rgba(255,255,255,0.6);
  }
}
</style>
